var map = {
	"./Group18619.svg": 6851,
	"./Indige-metaverse.png": 80,
	"./Indigewhite2.png": 2619,
	"./IngiverseGif.gif": 2367,
	"./JohnImage.png": 1359,
	"./NFT-collections.png": 8949,
	"./NewHomeBackCompress.png": 7368,
	"./Old_images/Aaron.jpg": 4485,
	"./Old_images/Celine.jpg": 7522,
	"./Old_images/Connor.jpg": 9298,
	"./Old_images/INDIGE_NFTLOGO 2@2x.png": 3362,
	"./Old_images/INDIGE_NFTLOGO.png": 8773,
	"./Old_images/Indige-handlogo.png": 4838,
	"./Old_images/IndigeNFT_2022.pdf": 467,
	"./Old_images/IndigeNFT_Roadmap_22.pdf": 6687,
	"./Old_images/Irina.jpg": 5266,
	"./Old_images/JOHNPAINTINGS.png": 7523,
	"./Old_images/JOHNPAINTINGS2x.png": 2668,
	"./Old_images/John.png": 6256,
	"./Old_images/JohnS.png": 4698,
	"./Old_images/Johnphotoesktop.svg": 2531,
	"./Old_images/Mariah.jpg": 9699,
	"./Old_images/about-img.png": 5160,
	"./Old_images/background3.png": 1922,
	"./Old_images/backgroundpage2.png": 7065,
	"./Old_images/cross.png": 6978,
	"./Old_images/homebackground.png": 544,
	"./Old_images/indige-40.jpg": 3295,
	"./Old_images/indige-banner.png": 6335,
	"./Old_images/indige-biglogo.png": 2082,
	"./Old_images/indige-logo.png": 5221,
	"./Old_images/indigeNFT-roadmap2022.pdf": 4526,
	"./Old_images/indige_img_1.png": 8225,
	"./Old_images/indige_img_2.png": 9219,
	"./Old_images/indige_img_3.png": 3294,
	"./Old_images/indige_img_4.png": 213,
	"./Old_images/indige_img_5.png": 252,
	"./Old_images/johnpainting.png": 7567,
	"./Old_images/mariah-final-1.png": 3952,
	"./Old_images/mariah-final.png": 1630,
	"./Old_images/menu-icon.png": 9235,
	"./Old_images/missionbackground.png": 1170,
	"./Old_images/mobile-background.png": 2527,
	"./Old_images/nfts-background-mobile.png": 5394,
	"./Old_images/ourMission-mobileback.png": 294,
	"./Old_images/ourMission.png": 731,
	"./Old_images/paintsplash-1.png": 8543,
	"./Old_images/paintsplash2.png": 5251,
	"./Old_images/pause-button1.svg": 7944,
	"./Old_images/place-holder1.png": 7587,
	"./Old_images/place-holder2.png": 1038,
	"./Old_images/place-holder3.png": 3246,
	"./Old_images/place-holder4.png": 5040,
	"./Old_images/place-holder5.jpg": 5352,
	"./Old_images/place-holder5.png": 3652,
	"./Old_images/placeholder.svg": 9186,
	"./Old_images/quotesection.png": 9652,
	"./Old_images/risidiologofinal.png": 6286,
	"./Old_images/roadmap.png": 4428,
	"./Old_images/roadmap.svg": 2537,
	"./Old_images/searchtool.png": 1259,
	"./Old_images/video-background-1.png": 5968,
	"./Old_images/video-background.png": 1457,
	"./arrow-down.png": 4010,
	"./arrowdown.png": 3433,
	"./arrowup.png": 9833,
	"./icons/Not_Using/atom-icon-arrow-down-dark.svg": 8119,
	"./icons/Not_Using/atom-icon-arrow-up-dark.svg": 5167,
	"./icons/Not_Using/atom-icon-play-dark.svg": 9658,
	"./icons/Not_Using/atom-icon-search-dark.svg": 6259,
	"./icons/atom-icon-close-dark.svg": 7603,
	"./icons/atom-icon-discord-dark.svg": 4025,
	"./icons/atom-icon-instagram-dark.svg": 2805,
	"./icons/atom-icon-menu-dark.svg": 8985,
	"./icons/atom-icon-twitter-dark.svg": 4442,
	"./icons/iconDiscord.svg": 5299,
	"./icons/iconInsta.svg": 2578,
	"./icons/iconInsta2.svg": 3419,
	"./icons/iconTwitter.svg": 5941,
	"./icons/newtab.png": 8774,
	"./indige-41.jpg": 5138,
	"./indige-marketplace.png": 1307,
	"./indige_images/1.png": 1098,
	"./indige_images/10.png": 2573,
	"./indige_images/100.png": 7921,
	"./indige_images/11.png": 9279,
	"./indige_images/12.png": 5911,
	"./indige_images/13.png": 4946,
	"./indige_images/14.png": 4763,
	"./indige_images/15.png": 9125,
	"./indige_images/16.png": 265,
	"./indige_images/17.png": 4528,
	"./indige_images/2.png": 1912,
	"./indige_images/20.png": 4577,
	"./indige_images/21.png": 9488,
	"./indige_images/22.png": 6401,
	"./indige_images/23.png": 9075,
	"./indige_images/24.png": 1707,
	"./indige_images/25.png": 1883,
	"./indige_images/26.png": 4449,
	"./indige_images/27.png": 3747,
	"./indige_images/28.png": 6754,
	"./indige_images/29.png": 5564,
	"./indige_images/3.png": 7446,
	"./indige_images/30.png": 5764,
	"./indige_images/31.png": 9603,
	"./indige_images/34.png": 2088,
	"./indige_images/35.png": 7189,
	"./indige_images/36.png": 8589,
	"./indige_images/37.png": 1917,
	"./indige_images/38.png": 414,
	"./indige_images/39.png": 3990,
	"./indige_images/4.png": 2010,
	"./indige_images/40.png": 8865,
	"./indige_images/41.png": 241,
	"./indige_images/42.png": 3682,
	"./indige_images/43.png": 1127,
	"./indige_images/44.png": 3891,
	"./indige_images/444.png": 8211,
	"./indige_images/45.png": 8327,
	"./indige_images/46.png": 5110,
	"./indige_images/47.png": 7550,
	"./indige_images/48.png": 343,
	"./indige_images/488.png": 2233,
	"./indige_images/49.png": 5878,
	"./indige_images/5.png": 5477,
	"./indige_images/50.png": 6604,
	"./indige_images/51.png": 3216,
	"./indige_images/52.png": 7412,
	"./indige_images/53.png": 1214,
	"./indige_images/54.png": 358,
	"./indige_images/55.png": 8010,
	"./indige_images/56.png": 4269,
	"./indige_images/57.png": 9336,
	"./indige_images/58.png": 3660,
	"./indige_images/6.png": 500,
	"./indige_images/7.png": 2429,
	"./indige_images/8.png": 8625,
	"./indige_images/9.png": 1575,
	"./indige_images/99.png": 4886,
	"./indige_images/Elton_John.png": 6219,
	"./indige_images/John_Lennon.png": 1016,
	"./indige_images/Neil_Armstrong.png": 7302,
	"./indige_images/New_Patty_Mills.png": 1610,
	"./indige_images/Patty_Mills.png": 6474,
	"./indige_images/Prince.png": 3122,
	"./indigelogo-hand.png": 6984,
	"./johnthumbnail.png": 7264,
	"./nfts-alot.jpeg": 9232,
	"./pause-button.svg": 9835,
	"./play-button.svg": 5508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;